export interface FeeSchedule {
    brokerage: number
    exchange: number
    cma: number
    cdsc: number
    funds: number
}

export interface FeeLine {
    key: keyof FeeSchedule
    label: string
    rate: number
    amount: number
}

export interface FeeBreakdown {
    lines: FeeLine[]
    total: number
    rate: number
}

export const SMALL_TRADE_LIMIT = 100000

export const SMALL_TRADE_FEES: FeeSchedule = {
    brokerage: 1.76,
    exchange: 0.12,
    cma: 0.12,
    cdsc: 0.08,
    funds: 0.02
}

export const LARGE_TRADE_FEES: FeeSchedule = {
    brokerage: 1.5,
    exchange: 0.12,
    cma: 0.12,
    cdsc: 0.08,
    funds: 0.02
}

export const FEE_LABELS: Record<keyof FeeSchedule, string> = {
    brokerage: 'Brokerage commission',
    exchange: 'Exchange levy',
    cma: 'CMA levy',
    cdsc: 'CDSC levy',
    funds: 'Investor compensation and guarantee funds'
}

export const DIVIDEND_TAX = {
    resident: 5,
    nonResident: 15
}

export const scheduleFor = (consideration: number): FeeSchedule => (consideration > SMALL_TRADE_LIMIT ? LARGE_TRADE_FEES : SMALL_TRADE_FEES)

export const feeBreakdown = (consideration: number, schedule: FeeSchedule = scheduleFor(consideration)): FeeBreakdown => {
    const keys = Object.keys(FEE_LABELS) as Array<keyof FeeSchedule>
    const lines = keys.map(key => ({
        key,
        label: FEE_LABELS[key],
        rate: schedule[key],
        amount: (Math.max(0, consideration) * schedule[key]) / 100
    }))
    const total = lines.reduce((acc, line) => acc + line.amount, 0)

    return { lines, total, rate: consideration > 0 ? (total / consideration) * 100 : 0 }
}

export const totalRate = (schedule: FeeSchedule): number => schedule.brokerage + schedule.exchange + schedule.cma + schedule.cdsc + schedule.funds
